"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZugentlastungTyp = exports.ZugentlastungMounting = void 0;
var ZugentlastungMounting;
(function (ZugentlastungMounting) {
    ZugentlastungMounting[ZugentlastungMounting["mitnehmer"] = 0] = "mitnehmer";
    ZugentlastungMounting[ZugentlastungMounting["festpunkt"] = 1] = "festpunkt";
    ZugentlastungMounting[ZugentlastungMounting["beidseitig"] = 2] = "beidseitig";
})(ZugentlastungMounting = exports.ZugentlastungMounting || (exports.ZugentlastungMounting = {}));
var ZugentlastungTyp;
(function (ZugentlastungTyp) {
    ZugentlastungTyp["Buegelschelle"] = "B\u00FCgelschelle";
    ZugentlastungTyp["Kettenkamm"] = "Kettenkamm";
    ZugentlastungTyp["Clips"] = "Clips";
    ZugentlastungTyp["Zugentlastungstrennsteg"] = "Zugentlastungstrennsteg";
    ZugentlastungTyp["Zugentlastungselement"] = "Zugentlastungselement";
    ZugentlastungTyp["Zugentlastungsstein"] = "Zugentlastungsstein";
    ZugentlastungTyp["KMA_C_Profil"] = "KMA_C-Profil";
    ZugentlastungTyp["HD_C_Profil"] = "HD_C-Profil";
    ZugentlastungTyp["Hutschiene"] = "Hutschiene";
    ZugentlastungTyp["Kabelbinder"] = "Kabelbinder";
})(ZugentlastungTyp = exports.ZugentlastungTyp || (exports.ZugentlastungTyp = {}));
//# sourceMappingURL=ZugentlastungModel.js.map